import { useState, useEffect } from 'react';

import Checkbox from 'components/common/checkbox/checkbox';
import DisclaimerIcon from 'components/icons/DisclaimerIcon';

type CheckboxProps = {
  onChange: (prop: boolean) => void;
};

import {
  StyledWrapper,
  StyledText,
  StyledTopHeading,
  StyledTitle
} from './disclaimer.style';

const Disclaimer = ({
  onChange = () => {}
}: React.PropsWithChildren<CheckboxProps>) => {
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    onChange(disabled);
  }, [disabled]);

  return (
    <StyledWrapper>
      <StyledTopHeading>
        <DisclaimerIcon color="#f3e3ab" />
        <StyledTitle>Disclaimer</StyledTitle>
      </StyledTopHeading>

      <StyledText>
        PLEASE READ: Your funds will be locked and you will be unable to access
        them once the pool closes and the delegation period begins (minimum 6
        months).
      </StyledText>
      <Checkbox onChange={(checked) => setDisabled(!checked)} type="middle">
        <b>I understand the pool locking conditions and wish to proceed.</b>
      </Checkbox>
    </StyledWrapper>
  );
};

export default Disclaimer;
